import { Observable, timer } from 'rxjs';
import { AccountUpdateType } from './../../_models/enums/accountUpdateType';
import { AccountUpdateRequest } from './../../_models/accountUpdateRequest';
import { AccountService } from './../../_services/account.service';
import { User } from './../../_models/user';
import { ApiService } from './../../_services/api.service';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SetupComponent implements OnInit {

  loading: boolean;
  ok: boolean;  
  error: boolean;  
  submitted: boolean;
  user: User = new User();

  constructor(
    private apiService: ApiService,
    private acountService: AccountService,
    private formBuilder: FormBuilder) {
    //let's not mess with original user 
    Object.assign(this.user, {}, this.acountService.userValue);
  }

  

  private showSaved() {
    setTimeout(() => { this.ok = true;  });
    timer(5000).subscribe(() => { this.ok = false;  });              
  }

  private showError() {
    setTimeout(() => { this.error = true;  })         
    timer(5000).subscribe(() => { this.error = false;  });              
  }

  private doUpdate(type: AccountUpdateType) {
    this.loading = true;
    const update = new AccountUpdateRequest();
    update.updateType = type;
    update.user = this.user;
    this.apiService.updateAccount(update).subscribe(response => {
      this.loading = false;
      if (response.code == 200) {
        this.acountService.updateUser(this.user);
        this.showSaved();
      } else {
        console.log(response);
        this.showError();
      }
    });
  }

  ngOnInit(): void {

  }


  onPersonalSubmit() {
    this.doUpdate(AccountUpdateType.PERSONAL);
  }

  onSecuritySubmit() {
    this.doUpdate(AccountUpdateType.SECURITY);    
  }  
}
